export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS'
export const GET_PAYMENT_METHODS_FAILED = 'GET_PAYMENT_METHODS_FAILED'
export const GET_PAYMENT_METHODS_SUCCEEDED = 'GET_PAYMENT_METHODS_SUCCEEDED'
